import Cookies from 'js-cookie'

const TokenKey = 'access_token'

const ExpiresInKey = 'Admin-Expires-In'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeAllToken(TokenKey = "Admin-Token") {
  localStorage.removeItem("access_token_long");
  Cookies.remove("access_token");
  return Cookies.remove(TokenKey);
}

export function setLongToken(token, TokenKey = "access_token_long") {
  return localStorage.setItem(TokenKey, token);
}

export function getLongToken(TokenKey = "access_token_long") {
  return localStorage.getItem(TokenKey);
}

export function setShortToken(token, TokenKey = "access_token") {
  return Cookies.set(TokenKey, token);
}

export function getShortToken(TokenKey = "access_token") {
  return Cookies.get(TokenKey);
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}

export const saveLoginInfo = (user={},access_token='') => {
  const VUE_X_KEY = "vuex"
  const origin = JSON.parse(localStorage.getItem(VUE_X_KEY) || '{}')
  const useful = {}
  Object.keys(user).forEach(k => {
    if (user[k] != null && !['password'].includes(k)) { // 只存有效的字段
      useful[k] = user[k]
    }
  })

  const combined = { // 合并必要的数据
    ...origin,
    auth: {
      ...(origin.auth || {}),
      accessToken: access_token,
      user: useful
    }
  }
  localStorage.setItem(VUE_X_KEY, JSON.stringify(combined)) // 存Nuxt用到的Vuex数据
  // console.log('已设置登录信息', JSON.stringify(combined))
}